export const CARD_COLOR = Styles.color.grey.six;
